/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackagesKpiDto } from '../../models/work-packages-kpi-dto';

export interface GetWorkPackagesKPI$Params {
  projectIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  dynamicGrouping?: string;
}

export function getWorkPackagesKPI(http: HttpClient, rootUrl: string, params?: GetWorkPackagesKPI$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagesKpiDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackagesKPI.PATH, 'get');
  if (params) {
    rb.query('projectIds', params.projectIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('dynamicGrouping', params.dynamicGrouping, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackagesKpiDto>;
    })
  );
}

getWorkPackagesKPI.PATH = '/v0/workPackages/kpi';
